import FormHelper from '#/js/helpers/FormHelper';

export default function () {
  FormHelper.target('#deactivateForm').confirm();
  FormHelper.target('#unlinkForm').confirm();
  FormHelper.target('#setAllPaidForm').confirm();
  FormHelper.target('.setPaidForm').confirm();
  FormHelper.target('#editReferral').confirm({
    text: Lang.get('referral.confirm'),
  });
}
